import AppShell from '@/components/AppShell'
import ContactMessageFloating from '@/components/contact/ContactMessageFloating'
import { HeroSection } from '@/components/home/HeroSection'
import { ProblemsSection } from '@/components/home/ProblemsSection'
import { ProcessSection } from '@/components/home/ProcessSection'
import { SecuritySection } from '@/components/home/SecuritySection'
import { CTASection } from '@/components/home/CTASection'

function Home() {
  return (
    <AppShell>
      <div className="bg-shire-light font-body text-shire-dark">
        <HeroSection />
        <ProblemsSection />
        <ProcessSection />
        <SecuritySection />
        <CTASection />
      </div>
      <ContactMessageFloating />
    </AppShell>
  )
}

export default Home
